import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { ServerConfig } from '../model/response/server-config.model';

export const ServerConfigPath = 'api/config/serverConfig';

@Injectable({
  providedIn: 'root'
})
export class ServerConfigService {
  private apiServerUrl: string;

  constructor(private readonly http: HttpClient, private readonly apiRef: ApiProviderService) {
    this.apiServerUrl = this.apiRef.getApiUrl(ServerConfigPath);
  }

  get(): Observable<ServerConfig> {
    return this.http.get<ServerConfig>(this.apiServerUrl)
      .pipe(
        map((response: any) => {
          return response['result'] as ServerConfig;
        })
      );
  }
}
